import { User } from "../../Models/User";

export interface IUserAuthState {
  user?: User;
  authorized: boolean;
}

export const initialUserAuthState: IUserAuthState = {
  user: undefined,
  authorized: false,
};
